import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Redirect } from 'react-router-dom'
import { updateSortOptions } from '../../store/actions/restaurantActions'
import Checkbox from '../layout/CheckboxBlack'
import Select from 'react-select';

class SortingOptions extends Component {

  constructor (props){
    super(props);
    this.state = {
    sortFavorites: false,
    sortOnlineNotMenu: false,
    sortOpen: false,
    sortPickup: true,
    sortDistance: true,
    anyTags: true,
    allTags: false,
    sortTags: '',
    openList: '',
    options: '',
    allContent: '',
    sortNames:'',
    sortName:'',
    sortCombined:'',
    combinedSort:'',
    carouselPosition:1,
    summaryChange:false,
    
    httpResponse:'',
    locationList:'',
    locationList2:'',
    distanceList:{},
    distanceList2:{},
    fullDistanceList:{},

    doOnce:true,
    doOnceAPI:true,
    doOnceDistance:true,
    prevDistanceListLength:999,
    sliderWidth:document.body.clientWidth - 20
        }
  }

  componentDidMount(props){
    this.setState({mount:true});
    this.setState({...this.props.restaurant.sortOptions})
  }

  componentDidUpdate(){
   if(this.state.localChange && JSON.stringify(this.state) !== JSON.stringify(this.props.restaurant.sortOptions)){
    this.props.updateSortOptions(this.state)
    this.setState({"localChange":false})
    //console.log('local change')
   }
   else if(this.props.restaurant.sortOptions.searchBar && JSON.stringify(this.state) !== JSON.stringify(this.props.restaurant.sortOptions)){
    this.props.updateSortOptions({...this.props.restaurant.sortOptions, "searchBar":false})
    this.setState({...this.props.restaurant.sortOptions, "searchBar":false, "localChange": false})
    //console.log('search bar change')
   }
   else if(this.props.restaurant.sortOptions.summaryChange && JSON.stringify(this.state) !== JSON.stringify(this.props.restaurant.sortOptions)){
    this.props.updateSortOptions({...this.props.restaurant.sortOptions, "summaryChange":false})
    this.setState({...this.props.restaurant.sortOptions, "summaryChange":false, "localChange": false})
    //console.log('summary change')
    }
  }

  handleCheck = (e) => {
    if(e.target.id==="anyTags"){
      this.setState({
        "allTags": false,
        "localChange": true
      })  
    }
    if(e.target.id==="allTags"){
      this.setState({
        "anyTags": false,
        "localChange": true
      })  
    }
    if(e.target.id !== 'sortFavorites'){
      this.setState({
        [e.target.id]: e.target.checked,
        "localChange": true
       })   
    }
    else{
      if(this.props.favorites[this.props.auth.uid] && this.props.user.firstName !== "Guest"){
      //console.log('this')
      //console.log(this.props.favorites)
      this.setState({
        [e.target.id]: e.target.checked,
        "localChange": true
       })   
      }
      else if(this.props.user.firstName === "Guest"){
        alert("Guest Users may not add favorites")
      }
      else if(!this.props.favorites[this.props.auth.uid]){
        alert("You don't have any favorites yet!")
      }
    }
   
 }

 handleSelect = (selection) =>{
    let combined = selection.concat(this.props.restaurant.sortOptions.sortName);
    //console.log('combined')
    //console.log(combined)
    this.setState({ sortTags: selection, "localChange": true, "sortCombined": combined });
  }

  handleSortNames = (selection) => {
    let combined = selection.concat(this.props.restaurant.sortOptions.sortTags);
    //console.log('combined')
    //console.log(combined)
    this.setState({sortName: selection, "localChange": true, "sortCombined": combined})
  }

  render(){
  	const {auth} = this.props
  	if (!auth.uid) return <Redirect to='/signin' />
  
  	return(
      <div className={!this.props.noWrapper ? "wrapper4" : undefined} style={{display:"block"}}>
        <h5>Sorting Options</h5>
        <div className="sortOptionsMenu">
            <Checkbox label = 'Contains any of the selected tags' id='anyTags' isSelected={this.state.anyTags} onCheckboxChange = {this.handleCheck} />
            <Checkbox label = 'Contains all of the selected tags' id='allTags' isSelected={this.state.allTags} onCheckboxChange = {this.handleCheck} />
            <h6>Tags</h6>
            <Select isMulti options={this.state.options} onFocus={this.selectFocus} value={this.state.sortTags} onChange={this.handleSelect} maxMenuHeight={100} />
            <Checkbox label = 'Online Ordering Available' id='sortOnlineNotMenu' isSelected = {this.state.sortOnlineNotMenu} onCheckboxChange = {this.handleCheck} />
            <Checkbox label = 'Include Pickup' id='sortPickup' isSelected = {this.state.sortPickup} onCheckboxChange = {this.handleCheck} />
            <Checkbox label = 'Currently Open' id='sortOpen' isSelected = {this.state.sortOpen} onCheckboxChange = {this.handleCheck} />
            {/* <Select options={allContentOptions} onChange={this.handleAllContent}/> */}
            {/*<h6>Restaurants</h6>
            <Select isMulti value={this.state.sortName} options={this.state.sortNames} onChange={this.handleSortNames} maxMenuHeight={100}/>*/}
            <Checkbox label = 'Distance' id='sortDistance' isSelected={this.state.sortDistance} onCheckboxChange = {this.handleCheck} />
            <Checkbox label = 'Favorites' id='sortFavorites' isSelected = {this.state.sortFavorites} onCheckboxChange = {this.handleCheck} />
        </div>
      </div>
  	)
  }

}

const mapStateToProps = (state) => {
  const user = state.firestore.data.users
                && state.firestore.data.users[state.firebase.auth.uid]
  return {
    auth: state.firebase.auth,
    restaurant: state.restaurant,
    favorites: state.firestore.data.favorites,
    user
  }
}

const mapDispatchToProps = dispatch => {
  return {
    updateSortOptions: (state) => dispatch(updateSortOptions(state))
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(SortingOptions)